import type {DefaultReport, DefaultReportGrouping} from './types';

export const LEAD_REPORTS: Array<DefaultReport> = [
    {
        type: 'sales',
        name: 'Sales',
        description: 'Monitor your total sales volume, quotas, and average lead value.',
        url: '/reports/sales/details',
        illustration: 'reports-overview/report-sales',
    },
    {
        type: 'losses',
        name: 'Losses',
        description: 'Evaluate total value lost and missed quota opportunities.',
        url: '/reports/losses/details',
    },
    {
        type: 'newleads',
        name: 'New leads',
        description: 'Assess lead volume, average value, and pipeline duration',
        url: '/reports/newleads/details',
    },
    {
        type: 'attribution',
        name: 'Attribution',
        description: 'Analyze channels for the most high-value leads and wins.',
        url: '/reports/attribution/details',
    },
    {
        type: 'forecast',
        name: 'Forecast',
        description: 'Track sales, pipeline value, projections, and quota status.',
        url: '/reports/forecast/details',
    },
    {
        type: 'custom',
        name: 'Custom',
        description: 'Filter all lead value and compare with lead quotas',
        url: '/reports/custom/details',
    },
];

export const EFFORT_REPORTS: Array<DefaultReport> = [
    {
        type: 'activity',
        name: 'Activity',
        description:
            'Understand activity impact: monitor ownership, lead generation, AI-driven tasks, and notes across your pipeline.',
        url: '/reports/activity/details',
        illustration: 'reports-overview/report-activity',
    },
    {
        type: 'email',
        name: 'Email',
        description: 'Break down outbound email performance across your team',
        url: '/reports/email/details',
    },
    {
        type: 'tasks',
        name: 'Task',
        description: 'View overall task progress with detailed pipeline insights',
        url: '/reports/tasks/details',
    },
];

export const OTHER_REPORTS: Array<DefaultReport> = [
    {
        type: 'funnel',
        name: 'Funnel',
        description: 'Understand how prospects move through each pipeline stage',
        url: '/reports/funnel/details',
        illustration: 'reports-overview/report-funnel',
    },
    {
        type: 'engagement',
        name: 'Engagement',
        description: "Assess your chat widget's visitor to lead conversion",
        url: '/reports/engagement/details',
    },
    {
        type: 'chatbot',
        name: 'Chatbot',
        description: 'How are users interacting with your chatbot?',
        url: '/reports/chatbot',
    },
    {
        type: 'email-digests',
        name: 'Email digests',
        description:
            'Weekly email digests that keep you updated on your team’s sales activity and performance.',
        url: '/my-account/email-digests',
        illustration: 'reports-overview/email-digests',
        cta: {
            text: 'Go to email digest settings',
            actionType: 'routed-link',
            url: '/my-account/email-digests',
            newTab: false,
        },
    },
];

export function getReportsForGrouping(grouping: DefaultReportGrouping): Array<DefaultReport> {
    switch (grouping) {
        case 'lead':
            return LEAD_REPORTS;
        case 'effort':
            return EFFORT_REPORTS;
        case 'other':
            return OTHER_REPORTS;
        default:
            return [];
    }
}

export function getReportGroupingName(grouping: DefaultReportGrouping): string {
    switch (grouping) {
        case 'lead':
            return 'Lead';
        case 'effort':
            return 'Effort';
        case 'other':
        default:
            return 'Other';
    }
}
